import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=e2f11fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f11fb0"]])

export default __exports__